export function getRandomValue() {
  const MAX_UNSIGNED_INT = 2 ** 32;
  const crypto = window.crypto;
  if (!crypto) {
    throw new Error(
      "Secure random number generation is not supported in this environment.",
    );
  }
  const array = new Uint32Array(1);
  crypto.getRandomValues(array);

  return array[0] / MAX_UNSIGNED_INT;
}
